import { addNotificationAction } from '../../../../store/notifications/actions';
import AbstractChatNotificationEventCatcher from '../../AbstractChatNotificationEventCatcher';

export default class ProjectMessagesNotificationEventCatcher extends AbstractChatNotificationEventCatcher {
  static process(notificationInfo, dispatch) {
    dispatch(addNotificationAction(notificationInfo));
  }
}
